import React from 'react';
import { Link as MuiLink } from '@mui/material';

const Link = props => <MuiLink {...props} />;

export default Link;
